/* @flow */
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';
import { OrderedMap, Map, List } from 'immutable';
import isString from 'lodash.isstring';
import escapeRegExp from 'lodash.escaperegexp';
import { allFeedsAndSubs } from 'modules/marketplace/getters.js';
import { ManagedSubscription } from 'modules/subscription-management/types.js';
// export const templatesMap = getterFromKeyPath(['subscription-management', 'templates']);
export const managedSubscriptionsMap = getterFromKeyPath(['subscriptionManagement', 'managedSubscriptions']);
export const loading = getterFromKeyPath(['subscriptionManagement', 'loading']);
export const displayOptions = getterFromKeyPath(['subscriptionManagement', 'options']);

/* Grabs all the managed subscriptions,
as an OrderedMap of ManagedSubscription Records */
export const allManagedSubs = createSelector(
  [ allFeedsAndSubs, managedSubscriptionsMap ],
  (subscribebabbles: OrderedMap<any, any>, managedSubscriptions: Map<any, List<any>>) => {
    let result = new List();
    if (managedSubscriptions && managedSubscriptions.size > 0) {
      // filter thru the ManagedSubscriptions to grab only the ones that require credentials/activation
      // go thru the managedSubscriptions and see if by the feedGuid, there is a corresponding subscription with that feedGuid

      // managedSubscriptions is a Map<feedGuid, List<Map>>
      result = managedSubscriptions.map(feed => {
        return feed.map(f => {
          const sub = subscribebabbles.get(f.get('feedGuid'));
          // if there is a corresponding sub: grab its relevant properties, and use them along with
          // the feed properties to create the ManagedSubscription Record
          return ManagedSubscription({
            feedGuid: f.get('feedGuid'),
            maximumAccess: sub.maximumAccess,
            name: sub.name,
            iconUrl: sub.iconUrl,
            description: sub.description,
            credentialsType: sub.credentialsType,
            externalUrl: sub.externalUrl,
            label: sub.label,
            created: sub.created,
            updated: sub.updated,
            enclaveGuid: f.get('enclaveGuid'),
            companyGuid: f.get('companyGuid'),
            companyName: f.get('companyName'),
            state: f.get('state'),
            lastPulled: sub.lastPulled,
          });
        });
      });
    }
    return result;
  }
);

/* From all the managed subscriptions, puts them in a list
and grabs the ones that actually require credentials */
export const allManagedSubsList = createSelector(
  [ allManagedSubs ],
  (managed: OrderedMap<any, any>) => {
    let result = new List();
    if (managed && managed.size > 0) {
      result = managed.toList();
    }
    return result;
  }
);


/* Grab a specific managed subscription, based on the guid  */
export const managedSubscription = (guid: string) => createSelector(
  managedSubscriptionsMap,
  (subs) => {
    if (subs !== null) {
      return subs.get(guid);
    }
  }
);

/* Generate initial form values for save/edit enclave subscription modal */
export const getSubscriptionFormValues = (guid: string) => createSelector(
  managedSubscription(guid),
  (sub) => {
    return sub.get('credentials');
  }
);



// WEBPACK FOOTER //
// ./src/app/modules/subscription-management/getters.js